<div class="row-items table-content" [ngClass]="{'even': isEven, 'odd': !isEven }" role="row">
    <ng-content></ng-content> 
</div>
